import { render } from "./DisplayMini.vue?vue&type=template&id=26a30a84"
import script from "./DisplayMini.vue?vue&type=script&lang=js"
export * from "./DisplayMini.vue?vue&type=script&lang=js"

import "./DisplayMini.vue?vue&type=style&index=0&id=26a30a84&lang=css"
script.render = render

export default script